export const AuthSeparator = () => (
  <div className="relative">
    <div className="absolute inset-0 flex items-center" aria-hidden="true">
      <div className="w-full border-t border-gray-200" />
    </div>
    <div className="relative flex justify-center">
      <span className="px-2 bg-purple-light text-lg">
        <h4>OR</h4>
      </span>
    </div>
  </div>
);
